import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Fires a GA4 page_view and a Meta Pixel PageView on every route change. index.html omits
// each library's own automatic first-load pageview specifically so this hook is the only
// source of pageviews - otherwise the library's own fire and this hook's first fire would
// double-count.
export function useAnalyticsPageview() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_title: document.title,
        page_location: window.location.href,
      });
    }
    if (typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [location.pathname, location.search]);
}
